import { ITest, RHookFormTextFieldWithLabel } from "@websential/cosmic";

import { FC } from "react";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { Grid } from "@mui/material";

interface IQPIPAndPPIPSettingsPanel extends ITest { }

export const QPIPAndPPIPSettingsPanel: FC<IQPIPAndPPIPSettingsPanel> = ({
  testId,
}) => {
  return (
    <Grid
      container
      columnSpacing={6}
      rowSpacing={2}
      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
    >
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Total Insurable Earnings (Maximum)"
          id="qpipPpipSettingsTotalInsurableEarningsMaximum"
          testId={`${testId}-total-insurable-earnings-maximum`}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Total Employee Premium (Maximum)"
          id="qpipPpipSettingsTotalEmployeePremiumMaximum"
          testId={`${testId}-total-employee-premium-maximum`}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <FieldWrapper>
          <RHookFormTextFieldWithLabel
            label="Employee Premium Rate (%)"
            id="qpipPpipSettingsEmployeePremiumRatePercentage"
            testId={`${testId}-employee-premium-rate-percentage`}
          />
        </FieldWrapper>
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <FieldWrapper>
          <RHookFormTextFieldWithLabel
            label="Employer Premium Rate (%)"
            id="qpipPpipSettingsEmployerPremiumRatePercentage"
            testId={`${testId}-employer-premium-rate-percentage`}
          />
        </FieldWrapper>
      </Grid>
    </Grid>
  );
};
